import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ChildType } from '@techstyle/react-virtual-scroll';
var PaginatedGridBatch = /*#__PURE__*/React.memo(function PaginatedGridBatch(_ref) {
  var _ref$as = _ref.as,
      ElementType = _ref$as === void 0 ? 'div' : _ref$as,
      childType = _ref.childType,
      getItems = _ref.getItems,
      loadItems = _ref.loadItems,
      renderItems = _ref.renderItems,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex,
      slots = _ref.slots;
  var ref = useRef();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      lastKnownHeight = _useState2[0],
      setLastKnownHeight = _useState2[1];

  var getItemsCached = useMemo(() => {
    var wasCalled = false;
    var items;
    return () => {
      if (wasCalled) {
        return items;
      }

      wasCalled = true;
      items = getItems({
        startIndex,
        stopIndex,
        slots
      });
      return items;
    };
  }, [getItems, startIndex, stopIndex, slots]);
  useEffect(() => {
    // update lastKnownHeight to show placeholder grids correctly
    if (ref.current && ref.current.getBoundingClientRect()) {
      setLastKnownHeight(ref.current.getBoundingClientRect().height);
    }

    if (childType === ChildType.ITEM && !getItemsCached()) {
      loadItems({
        startIndex,
        stopIndex
      });
    }
  }, [childType, getItemsCached, loadItems, renderItems, setLastKnownHeight, startIndex, stopIndex]);
  return /*#__PURE__*/React.createElement(ElementType, {
    ref: ref
  }, renderItems({
    items: getItemsCached(),
    startIndex,
    stopIndex,
    isVisible: true,
    lastKnownHeight
  }));
});
PaginatedGridBatch.propTypes = {
  as: PropTypes.elementType,
  childType: PropTypes.string,
  getItems: PropTypes.func,
  loadItems: PropTypes.func,
  renderItems: PropTypes.func,
  slots: PropTypes.arrayOf(PropTypes.object),
  startIndex: PropTypes.number,
  stopIndex: PropTypes.number
};
export default PaginatedGridBatch;